import { render, staticRenderFns } from "./EcoScoreOverviewView.vue?vue&type=template&id=266a6221&scoped=true&"
import script from "./EcoScoreOverviewView.vue?vue&type=script&lang=js&"
export * from "./EcoScoreOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./EcoScoreOverviewView.vue?vue&type=style&index=0&id=266a6221&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a6221",
  null
  
)

/* custom blocks */
import block0 from "./EcoScoreOverviewView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports